import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Eye, EyeOff, Loader2 } from "lucide-react";
import { apiFetch } from "@/lib/api";
import { toastError, toastSuccess } from "@/lib/toast";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import { helper } from "@/lib/helper";

export default function SetNewPasswordPage() {
  const navigate = useNavigate();
  const location = useLocation();
const login = location.state?.login;

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");


  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (password !== confirm) {
      return setError("Passwords do not match.");
    }

    const pwError = helper.validateStrongPassword(password);
    if (pwError) {
      return setError(pwError);
    }

    setLoading(true);

    try {
      await apiFetch("/auth/set-password", {
        method: "POST",
        body: JSON.stringify({
          login, // ✅ THIS WAS MISSING
          new_password: password,
          new_password_confirmation: confirm,
        }),
      });

      toastSuccess("Password updated successfully!");
      navigate("/login");
    } catch (e: any) {
      const msg = e?.message || "Failed to set password.";
      setError(msg);
      toastError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-md bg-card border border-border rounded-2xl p-8 shadow-card"
      >
        <h1 className="text-2xl font-bold mb-2">Set New Password</h1>
        <p className="text-sm text-muted-foreground mb-6">
          Your password has expired. Please set a new one to continue.
        </p>

        {error && (
          <div className="mb-4 text-sm text-destructive bg-destructive/10 p-3 rounded-lg border border-destructive/40">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* NEW PASSWORD */}
          
          <div>
            <Label>New Password</Label>
            <div className="relative">
              <Input
                placeholder="New Password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2"
              >
                {showPassword ? <EyeOff /> : <Eye />}
              </button>
            </div>
          </div>

          {/* CONFIRM PASSWORD */}
          <div>
            <Label>Confirm Password</Label>
            <div className="relative">
              <Input
                placeholder="Confirm Password"
                type={showConfirm ? "text" : "password"}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowConfirm((v) => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2"
              >
                {showConfirm ? <EyeOff /> : <Eye />}
              </button>
            </div>
          </div>

          {/* BUTTON */}
          <Button type="submit" className="w-full h-12" disabled={loading}>
            {loading ? (
              <span className="flex items-center gap-2">
                <Loader2 className="animate-spin h-4 w-4" />
                Updating...
              </span>
            ) : (
              "Update Password"
            )}
          </Button>
        </form>
      </motion.div>
    </div>
  );
}